<template>
  <v-row>
    <v-col cols="12">
      <p class="primary--text mb-5 list-sub-modality__title">
        SEGURADORA: {{ insurance.name }}
      </p>
      <p class="form__title gray--text mb-3">
        LIMITES DE CRÉDITO SUB-MODALIDADE
      </p>
    </v-col>
    <v-col
      v-for="(item, key) of listActiveSubModality"
      :key="key"
      cols="12"
      sm="5"
      md="3"
      class="pr-5 pb-5 d-flex justify-center justify-sm-start"
    >
      <QuotationCard
        @click="selectedItem(item)"
        :name="item.nome"
        :background="item.imagem"
        :class="{ 'base-card-active': findActiveItem(item) }"
      />
    </v-col>
  </v-row>
</template>
<script>
import CardDescriptionButton from "@/components/CardDescriptionButton.vue";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
export default {
  data: () => ({
    model: {},
    list: []
  }),
  components: {
    QuotationCard: CardDescriptionButton
  },
  mixins: [LoadingRequest, InsuranceCompanyMixin],
  created() {
    this.fetchSubModality();
  },
  computed: {
    ...mapState("quotation", ["listSubModality"]),
    listActiveSubModality() {
      return this.listSubModality.filter(
        x =>
          x.ativo == true &&
          !this.form.submodalidades.some(e => e.submodalidade.id === x.id)
      );
    },
    editSubModality() {
      return {
        name: "insurance_company edit sub modality",
        step: 2
      };
    },
    editModality() {
      return {
        name: "insurance_company edit modality",
        step: 2
      };
    }
  },
  methods: {
    ...mapActions("quotation", ["requestSubModalities"]),
    fetchSubModality() {
      this.model = this.form;
      this.withLoading(this.requestSubModalities(this.modality.id));
    },
    selectedItem(item) {
      this.model = item;
      this.$emit(
        "updateStep",
        this.payloadInsuranceCompany(this.model, this.editSubModality)
      );
    },
    findActiveItem(item) {
      return this.model ? item.id === this.model.id : false;
    }
  },
  props: {
    return: {
      type: Boolean
    },
    modality: {
      type: Object
    },
    insurance: {
      type: Object
    },
    form: {
      type: Object
    },
    subModality: {
      type: Object
    }
  },
  watch: {
    return(value) {
      if (value)
        this.$emit(
          "updateStep",
          this.payloadInsuranceCompany(this.model, this.editModality)
        );
    }
  }
};
</script>
<style lang="sass">
.list-sub-modality__title
  font-weight: 800
  font-size: 18px
</style>
